import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { handleArabicCharacters, prepareArabicText, prepareBillNotes, reverseArabicAndEnglish, reverseArabicAndEnglish2, reverseArabicAndEnglish3 } from "./utilies";
import {
  DroidKufiRegular,
  DroidKufiBold,
  AmiriReg,
  AmiriBold,
} from "./vfs_fonts";
import { backgroundImage1 } from "./backgrounImage";
import { sto } from "../../Context/InshData";
import moment from "moment";
import printJS from "print-js";
import { GetA4Setings } from "../../services/settings-services";
import { NotoArabicBold, NotoExtraBold, CairoBold, NotoSanREgular, NotoSimiBold } from "./vfs_noto"

pdfMake.vfs = pdfFonts.pdfMake.vfs;
window.pdfMake.vfs["DroidKufi-Regular.ttf"] = DroidKufiRegular;
window.pdfMake.vfs["DroidKufi-Bold.ttf"] = DroidKufiBold;
window.pdfMake.vfs["Amiri-Bold.ttf"] = AmiriBold;
window.pdfMake.vfs["Amiri-Regular.ttf"] = AmiriReg;
window.pdfMake.vfs["NotoSansArabic-Bold.ttf"] = NotoArabicBold;
window.pdfMake.vfs["NotoSansArabic_Condensed-ExtraBold.ttf"] = NotoExtraBold;
window.pdfMake.vfs["Cairo-ExtraBold.ttf"] = CairoBold;
window.pdfMake.vfs["NotoSansArabic-Regular.ttf"] = NotoSanREgular;
window.pdfMake.vfs["NotoSansArabic-SemiBold.ttf"] = NotoSimiBold;
pdfMake.fonts = {
  DroidKufiRegular: {
    normal: "DroidKufi-Regular.ttf",
    bold: "DroidKufi-Bold.ttf",
    italics: "DroidKufi-Regular.ttf",
    bolditalics: "DroidKufi-Regular.ttf",
  },
  Roboto: {
    normal: "Roboto-Medium.ttf",
    bold: "Roboto-Bold.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-ThinItalic.ttf",
  },
  Amiri: {
    normal: "Amiri-Regular.ttf",
    bold: "Amiri-Bold.ttf",
    italics: "Amiri-Regular.ttf",
    bolditalics: "Amiri-Regular.ttf",
  },
  NotoArabicBold: {
    normal: "NotoSansArabic-Bold.ttf",
    bold: "NotoSansArabic-Bold.ttf",
  },
  NotoExtraBold: {
    normal: "NotoSansArabic_Condensed-ExtraBold.ttf",
    bold: "NotoSansArabic_Condensed-ExtraBold.ttf",
  },
  CairoBold: {
    normal: "Cairo-ExtraBold.ttf",
    bold: "Cairo-ExtraBold.ttf",
  },
  NotoSanREgular: {
    normal: "NotoSansArabic-Regular.ttf",
    bold: "NotoSansArabic-Regular.ttf",
  },
  NotoSimiBold: {
    normal: "NotoSansArabic-SemiBold.ttf",
    bold: "NotoSansArabic-SemiBold.ttf",
  },
};

class pdfExport {
  static defaultSettings = localStorage.getItem("defaultSettings")
    ? JSON.parse(localStorage.getItem("defaultSettings"))
    : {
      defaultTemplate: "temp3",
    };

  static docDefinition = localStorage.getItem("docDefinition")
    ? JSON.parse(localStorage.getItem("docDefinition"))
    : {
      backgroundColor: "#0069D9",
      pageOrientation: "portrait",
      pageSize: "A4",
      watermark: {
        text: "",
        opacity: 0.3, 
        bold: false,
        italics: false,
      },
      qrCodeActive: false,
      qrCode: {
        qr: "",
        foreground: "#000000",
        background: "#FFFFFF",
        eccLevel: "L",
        appendInvoiceNo: false,
      },
    };

  static bill4Settings = GetA4Setings();

  static setSettings = () => {
    if (localStorage.getItem("defaultSettings")) {
      this.defaultSettings = JSON.parse(
        localStorage.getItem("defaultSettings")
      );
    }
    if (localStorage.getItem("docDefinition")) {
      this.docDefinition = JSON.parse(localStorage.getItem("docDefinition"));
    }
  };

  static downloadInvoice = (obj) => {
    this.setSettings();
    let docDefinition = this.getTemplateWithDef(obj);

    pdfMake.createPdf(docDefinition).download("Invoice No#" + obj.invoiceNo);
  };

  static shareInvoice = (obj) => {

    this.setSettings();
    let docDefinition = this.getTemplateWithDef(obj);

    pdfMake.createPdf(docDefinition).getBlob((blob) => {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.addEventListener('click', function () {

        a.download("orax invoice");
      });
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);
      // var whatsappUrl = "https://api.whatsapp.com/send?text="+encodeURIComponent("invoice from "+url);
      // var whatsappUrl = `https://wa.me/?text=${'hello'}`;
      // window.open(whatsappUrl, "_blank");
      if (navigator.share && navigator.canShare({ files: [blob] })) {
        navigator.share({
          title: "hello to orax app",
          text: "welcome this is text",
          url: "orax.app/",
          files: [blob],
          // pageStyle:"a4",
        });
      } else {
        alert("cant share files");
      }
    });


  };
  static openInvoice = (obj) => {
    this.setSettings();
    let docDefinition = this.getTemplateWithDef(obj);
    pdfMake.createPdf(docDefinition).open();
  };

  static printInvoice = (obj, newWindow = false) => {
    this.setSettings();
    let docDefinition = this.getTemplateWithDef(obj);

    if (newWindow) pdfMake.createPdf(docDefinition).print();
    else
      pdfMake
        .createPdf(docDefinition)
        .getBase64((data) =>
          printJS({ printable: data, type: "pdf", base64: true })
        );
  };

  static getRestInvoice = (obj) => {
    this.setSettings();
    let docDefinition = this.generateDocDefTemplate8(obj);
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    return pdfDocGenerator;
  };
  static getCashairInvoice = (obj) => {
    this.setSettings();
    let docDefinition = this.generateDocDefTempelteCashair(obj);
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    return pdfDocGenerator;
  };
  static getOpenDrawer = () => {
    this.setSettings();
    let docDefinition = this.openDrawerTemplate();
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);

    return pdfDocGenerator;
  };

  static getKitchenInvoice = (obj) => {
    this.setSettings();
    let docDefinition = this.generateDocDefTemplate9(obj);
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    return pdfDocGenerator;
  };

  static getSubtotal = (items) =>
    items
      .reduce((sum, item) => Number(sum) + Number(item.amount), 0)
      .toFixed(2);

  static getQtyTotal = (items) =>
    items.reduce((sum, item) => Number(sum) + Number(item.val1), 0).toFixed(2);

  static getTotalAmount = (tot) =>
    (tot?.tot_net - tot?.amountOfVat + tot?.discount)?.toFixed(2);

  static getTotal = (items, discounts, shipping) =>
    (
      this.getSubtotal(items) -
      Number(discounts || 0) +
      Number(shipping || 0)
    ).toFixed(2);

  static getTemplateWithDef = (obj) => {
    let docDef = null;
    console.log(
      "the defalut template is",
      this.defaultSettings.defaultTemplate
    );
    switch (this.defaultSettings.defaultTemplate) {
      case "temp1":
        docDef = this.generateDocDef(obj);
        break;
      case "temp2":
        docDef = this.generateDocDefTemplate2(obj);
        break;
      case "temp3":
        docDef = this.generateDocDefTemplate7(obj);
        break;
      case "temp4":
        docDef = this.generateDocDefTemplate8(obj);
        break;
      case "temp5":
        docDef = this.generateDocDefTemplate5(obj);
        break;
      case "temp6":
        docDef = this.generateDocDefTemplate6(obj);
        break;
      default:
        docDef = this.generateDocDef(obj);
        break;
    }
    // TODO: Remove on prod (This for demo purpose only)
    // docDef.watermark.text = "DEMO";
    // docDef.watermark.opacity = 0.5;
    // END TODO
    return docDef;
  };

  // Template 1 (Default)
  static generateDocDef = (obj) => {
    const {
      backgroundColor,
      watermark,
      pageSize,
      pageOrientation,
      qrCodeActive,
      qrCode,
    } = this.docDefinition;
    let itemBody = [
      [
        { text: "#", style: "tableHeader" },
        { text: "الصنف", style: "tableHeader", font: "DroidKufiRegular" },
        { text: "الكمية", style: "tableHeader", alignment: "center" },
        { text: "Rate", style: "tableHeader", alignment: "right" },
        {
          text: obj?.taxation ?? "GST",
          style: "tableHeader",
          alignment: "center",
        },
        { text: "Amount", style: "tableHeader", alignment: "right" },
      ],
    ];
    let itemArr = ["", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      itemBody.push([
        index + 1,
        { text: handleArabicCharacters(element.title) },
        { text: element.quantity, alignment: "center" },
        { text: element.rate, alignment: "right" },
        { text: element.taxationPer, alignment: "center" },
        { text: element.amount, alignment: "right" },
      ]);
    }
    let subTotalArr = [
      {
        width: "*",
        columns: [
          {
            width: "*",
            text: [
              {
                text: "Subtotal",
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: "Discounts",
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: "Shipping",
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 250,
                    y2: 5,
                    lineWidth: 3,
                  },
                ],
              },
              {
                text: "Total (" + (obj.currency || "USD") + ")",
                fontSize: 12,
                bold: true,
                alignment: "right",
              },
            ],
          },
          {
            width: "auto",
            text: [
              {
                text: this.getSubtotal(obj.items),
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: obj.discounts > 0 ? "-" + obj.discounts : obj.discounts,
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: obj.shipping,
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: this.getTotal(obj.items, obj.discounts, obj.shipping),
                fontSize: 12,
                bold: true,
                alignment: "right",
              },
            ],
          },
        ],
      },
    ];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      subTotalArr.push("\n\n");
      subTotalArr.push({
        qr: qrCode.qr + (qrCode?.appendInvoiceNo === true ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "right",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    var docDefinition = {
      pageSize: pageSize,
      pageOrientation: pageOrientation,
      watermark: {
        text: watermark.text,
        color: backgroundColor,
        opacity: Number(watermark.opacity),
        bold: false,
        italics: false,
      },
      info: {
        title: "Invoice No#" + obj.invoiceNo,
        author: "Invoice Generator",
        subject: "Invoice No#" + obj.invoiceNo,
        keywords: "Invoice No#" + obj.invoiceNo,
      },
      background: function (currentPage, pageSize) {
        return [
          {
            image: backgroundImage1,
            height: pageSize.height,
            width: pageSize.width,
            margin: [0, 0, 0, 0],
          },
        ];
      },
      footer: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 0,
                w: pageSize.width,
                h: 5,
                color: backgroundColor,
              },
            ],
          },
          {
            table: {
              widths: ["80%", "20%"],
              body: [
                [
                  {
                    text: obj.footNote,
                    alignment: "left",
                    fontSize: 7,
                    margin: [40, 0, 0, 0],
                  },
                  {
                    text:
                      "Page " +
                      currentPage.toString() +
                      " of " +
                      pageCount +
                      "   ",
                    alignment: "right",
                    margin: [0, 10, 40, 0],
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
        ];
      },
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 10,
                w: pageSize.width,
                h: 15,
                color: backgroundColor,
              },
            ],
          },
        ];
      },
      content: [
        {
          columns: [
            {
              width: "auto",
              columns: [
                {
                  image: obj.imgSrc
                    ? obj.imgSrc
                    : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
                  width: 100,
                  height: 100,
                },
              ],
            },
            {
              width: "*",
              text: [
                {
                  text: `${obj.title} #${obj.invoiceNo}`,
                  fontSize: 15,
                  bold: true,
                  alignment: "right",
                  lineHeight: 1.2,
                },
                "\n",
                {
                  text: "Invoice Date: " + obj.invoiceDate,
                  alignment: "right",
                },
                "\n",
                {
                  text: "Due Date: " + obj.dueDate,
                  alignment: "right",
                },
              ],
            },
          ],
        },
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            // dontBreakRows: true,
            // keepWithHeaderRows: 1,
            body: [
              [
                { text: "Bill From", style: "tableHeader" },
                { text: "Bill For", style: "tableHeader" },
              ],
              [obj.invoiceFrom, obj.invoiceTo],
            ],
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "*", 50, 60, 30, 80],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
          layout: "lightHorizontalLines",
        },
        {
          columns: [
            {
              width: "70%",
              text: [
                {
                  text:
                    obj.terms !== "" ? "Terms & Conditions\n" + obj.terms : "",
                  fontSize: 10,
                },
              ],
            },
            subTotalArr,
          ],
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5],
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "black",
        },
      },
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
        // font: "DroidKufiRegular",
      },
    };

    return docDefinition;
  };

  // Template 2
  static generateDocDefTemplate2 = (obj) => {
    const {
      backgroundColor,
      watermark,
      pageSize,
      pageOrientation,
      qrCodeActive,
      qrCode,
    } = this.docDefinition;
    let itemBody = [
      [
        { text: "#", style: "tableHeader", alignment: "right", color: "white" },
        { text: "Item", style: "tableHeader", color: "white" },
        {
          text: "Qty",
          style: "tableHeader",
          alignment: "center",
          color: "white",
        },
        {
          text: "Rate",
          style: "tableHeader",
          alignment: "right",
          color: "white",
        },
        {
          text: obj?.taxation ?? "GST",
          style: "tableHeader",
          alignment: "center",
          color: "white",
        },
        {
          text: "Amount",
          style: "tableHeader",
          alignment: "right",
          color: "white",
        },
      ],
    ];
    let itemArr = ["", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      itemBody.push([
        { text: index + 1, alignment: "right" },
        handleArabicCharacters(element.title),
        { text: element.quantity, alignment: "center" },
        { text: element.rate, alignment: "right" },
        { text: element.taxationPer, alignment: "center" },
        { text: element.amount, alignment: "right" },
      ]);
    }
    pdfMake.tableLayouts = {
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 0;
          }
          return i === node.table.headerRows ? 2 : 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return i === 1 ? "black" : "#aaa";
        },
        fillColor: function (i, node) {
          return i === 0 ? backgroundColor : i % 2 === 0 ? "#CCCCCC" : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
    };
    let qrArr = [];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      qrArr.push({
        qr: qrCode.qr + (qrCode?.appendInvoiceNo === true ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "left",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    var docDefinition = {
      pageSize: pageSize,
      pageOrientation: pageOrientation,
      watermark: {
        text: watermark.text,
        color: backgroundColor,
        opacity: Number(watermark.opacity),
        bold: false,
        italics: false,
      },
      info: {
        title: "Invoice No#" + obj.invoiceNo,
        author: "Invoice Generator",
        subject: "Invoice No#" + obj.invoiceNo,
        keywords: "Invoice No#" + obj.invoiceNo,
      },
      footer: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 0,
                w: pageSize.width,
                h: 3,
                color: backgroundColor,
              },
            ],
          },
          {
            table: {
              widths: ["80%", "20%"],
              body: [
                [
                  {
                    text: obj.footNote,
                    alignment: "left",
                    fontSize: 7,
                    margin: [40, 0, 0, 0],
                  },
                  {
                    text:
                      "Page " +
                      currentPage.toString() +
                      " of " +
                      pageCount +
                      "   ",
                    alignment: "right",
                    margin: [0, 10, 40, 0],
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
        ];
      },
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 0,
                w: pageSize.width,
                h: 10,
                color: backgroundColor,
              },
            ],
          },
        ];
      },
      content: [
        {
          columns: [
            {
              width: "auto",
              columns: [
                {
                  image: obj.imgSrc
                    ? obj.imgSrc
                    : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
                  width: 100,
                  height: 100,
                },
              ],
            },
            {
              width: "*",
              text: [
                {
                  text: obj.invoiceFrom,
                },
              ],
            },
            {
              width: "*",
              text: [
                {
                  text: `${obj.title} #${obj.invoiceNo}`,
                  fontSize: 15,
                  bold: true,
                  alignment: "right",
                  lineHeight: 1.2,
                },
                "\n",
                {
                  text: "Invoice Date: " + obj.invoiceDate,
                  alignment: "right",
                },
                "\n",
                {
                  text: "Due Date: " + obj.dueDate,
                  alignment: "right",
                },
              ],
            },
          ],
        },

        "\nBill To",
        {
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 },
          ],
        },
        obj.invoiceTo,
        "\n",
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "*", 50, 60, 30, 80],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
          layout: "exampleLayout",
          dontBreakRows: true,
        },
        {
          columns: [
            {
              width: "*",
              stack: qrArr,
            },
            {
              width: "auto",
              columns: [
                {
                  width: "*",
                  text: [
                    {
                      text: "Subtotal",
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text: "Discounts",
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text: "Shipping",
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text: "\t\t\tTotal (" + (obj.currency || "USD") + ")",
                      fontSize: 12,
                      bold: true,
                      alignment: "right",
                      background: backgroundColor,
                      color: "#FFF",
                    },
                  ],
                },
                {
                  width: "auto",
                  text: [
                    {
                      text: this.getSubtotal(obj.items),
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text:
                        obj.discounts > 0 ? "-" + obj.discounts : obj.discounts,
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text: obj.shipping,
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text: this.getTotal(
                        obj.items,
                        obj.discounts,
                        obj.shipping
                      ),
                      fontSize: 12,
                      bold: true,
                      alignment: "right",
                      background: backgroundColor,
                      color: "#FFF",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          text: [
            {
              text:
                obj.terms !== "" ? "\nTerms & Conditions\n" + obj.terms : "",
              fontSize: 10,
            },
          ],
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 0],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5],
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "black",
        },
      },
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };

  // Template 3
  static generateDocDefTemplate3 = (obj) => {
    const {
      backgroundColor,
      watermark,
      pageSize,
      pageOrientation,
      qrCodeActive,
      qrCode,
    } = this.docDefinition;
    let itemBody = [
      [
        { text: "#", style: "tableHeader", alignment: "right", color: "white" },
        { text: "Item", style: "tableHeader", color: "white" },
        {
          text: "Qty",
          style: "tableHeader",
          alignment: "center",
          color: "white",
        },
        {
          text: "Rate",
          style: "tableHeader",
          alignment: "right",
          color: "white",
        },
        {
          text: obj?.taxation ?? "GST",
          style: "tableHeader",
          alignment: "center",
          color: "white",
        },
        {
          text: "Amount",
          style: "tableHeader",
          alignment: "right",
          color: "white",
        },
      ],
    ];
    let itemArr = ["", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      itemBody.push([
        { text: index + 1, alignment: "right" },
        handleArabicCharacters(element.title),
        { text: element.quantity, alignment: "center" },
        { text: element.rate, alignment: "right" },
        { text: element.taxationPer, alignment: "center" },
        { text: element.amount, alignment: "right" },
      ]);
    }
    pdfMake.tableLayouts = {
      totalLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#aaa";
        },
        fillColor: function (i, node) {
          return i === 0 ? "#e8e8e8" : i % 2 === 0 ? "#e8e8e8" : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 0;
          }
          return i === node.table.headerRows ? 2 : 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return i === 1 ? "black" : "#aaa";
        },
        fillColor: function (i, node) {
          return i === 0 ? backgroundColor : i % 2 === 0 ? "#e8e8e8" : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
    };
    // -- Set the report date for display only.
    let reportDate = new Date().toDateString();
    let qrArr = [];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      qrArr.push("\n");
      qrArr.push({
        qr: qrCode.qr + (qrCode?.appendInvoiceNo === true ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "left",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    var docDefinition = {
      pageSize: pageSize,
      pageOrientation: pageOrientation,
      watermark: {
        text: watermark.text,
        color: backgroundColor,
        opacity: Number(watermark.opacity),
        bold: false,
        italics: false,
      },
      info: {
        title: "Invoice No#" + obj.invoiceNo,
        author: "Invoice Generator",
        subject: "Invoice No#" + obj.invoiceNo,
        keywords: "Invoice No#" + obj.invoiceNo,
      },
      footer: function (currentPage, pageCount, pageSize) {
        return {
          text: `${reportDate} : Page ${currentPage.toString()} of ${pageCount.toString()}`,
          alignment: "center",
          fontSize: 7,
        };
      },
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 10,
                w: pageSize.width,
                h: 3,
                color: backgroundColor,
              },
            ],
          },
        ];
      },
      content: [
        {
          columns: [
            {
              width: "*",
              text: [
                {
                  text: obj.invoiceFrom,
                },
              ],
            },
            {
              width: "auto",
              columns: [
                {
                  image: obj.imgSrc
                    ? obj.imgSrc
                    : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
                  width: 100,
                  height: 100,
                },
              ],
            },

            {
              width: "*",
              text: [
                {
                  text: `${obj.title} #${obj.invoiceNo}`,
                  fontSize: 15,
                  bold: true,
                  alignment: "right",
                  lineHeight: 1.2,
                },
                "\n",
                {
                  text: "Invoice Date: " + obj.invoiceDate,
                  alignment: "right",
                },
                "\n",
                {
                  text: "Due Date: " + obj.dueDate,
                  alignment: "right",
                },
              ],
            },
          ],
        },
        {
          layout: "lightHorizontalLines", // optional
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ["*"],

            body: [
              [{ text: "Bill To", bold: true, fillColor: "#F9F9F9" }],
              [{ text: obj.invoiceTo, fillColor: "#F9F9F9" }],
            ],
          },
        },
        "\n",
        {
          margin: [0, 0, 0, 0],
          layout: "exampleLayout",
          dontBreakRows: true,
          table: {
            headerRows: 1,
            widths: ["auto", "*", 50, 60, 30, 80],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
        },

        {
          columns: [
            {
              width: "*",
              stack: qrArr,
            },
            {
              width: "auto",
              columns: [
                {
                  layout: "totalLayout",
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 0,
                    widths: ["*", 80],

                    body: [
                      [
                        { text: "Subtotal", bold: true, alignment: "right" },
                        {
                          text: this.getSubtotal(obj.items),
                          bold: false,
                          alignment: "right",
                        },
                      ],
                      [
                        { text: "Discounts", bold: true, alignment: "right" },
                        {
                          text:
                            obj.discounts > 0
                              ? "-" + obj.discounts
                              : obj.discounts,
                          bold: false,
                          alignment: "right",
                        },
                      ],
                      [
                        { text: "Shipping", bold: true, alignment: "right" },
                        {
                          text: obj.shipping,
                          bold: false,
                          alignment: "right",
                        },
                      ],
                      [
                        {
                          text: "Total (" + (obj.currency || "USD") + ")",
                          bold: true,
                          alignment: "right",
                        },
                        {
                          text: this.getTotal(
                            obj.items,
                            obj.discounts,
                            obj.shipping
                          ),
                          bold: false,
                          alignment: "right",
                        },
                      ],
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          stack: [
            {
              text:
                obj.terms !== "" ? "\nTerms & Conditions\n" + obj.terms : "",
              fontSize: 10,
            },
            "\n\n\n\n\n",
            { text: "Signature / Stamp", color: backgroundColor },
            { text: "Place: " },
            { text: "Date: " },
          ],
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5],
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "black",
        },
      },
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };

  // Template 4
  static generateDocDefTemplate4 = (obj) => {
    const {
      backgroundColor,
      watermark,
      pageSize,
      pageOrientation,
      qrCodeActive,
      qrCode,
    } = this.docDefinition;
    let itemBody = [
      [
        { text: "#", style: "tableHeader", alignment: "right", color: "white" },
        { text: "Item", style: "tableHeader", color: "white" },
        {
          text: "Qty",
          style: "tableHeader",
          alignment: "center",
          color: "white",
        },
        {
          text: "Rate",
          style: "tableHeader",
          alignment: "right",
          color: "white",
        },
        {
          text: obj?.taxation ?? "GST",
          style: "tableHeader",
          alignment: "center",
          color: "white",
        },
        {
          text: "Amount",
          style: "tableHeader",
          alignment: "right",
          color: "white",
        },
      ],
    ];
    let itemArr = ["", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      itemBody.push([
        { text: index + 1, alignment: "right" },
        handleArabicCharacters(element.title),
        { text: element.quantity, alignment: "center" },
        { text: element.rate, alignment: "right" },
        { text: element.taxationPer, alignment: "center" },
        { text: element.amount, alignment: "right" },
      ]);
    }
    pdfMake.tableLayouts = {
      totalLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#aaa";
        },
        fillColor: function (i, node) {
          return i === 0 ? "#e8e8e8" : i % 2 === 0 ? "#e8e8e8" : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 1;
          }
          return i === node.table.headerRows ? 2 : 1;
        },
        vLineWidth: function (i) {
          return 1;
        },
        hLineColor: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return "black";
          }
          return i === 1 ? "black" : "#aaa";
        },
        fillColor: function (i, node) {
          return i === 0 ? backgroundColor : i % 2 === 0 ? "#e8e8e8" : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
    };
    // -- Set the report date for display only.
    let reportDate = new Date().toDateString();
    let qrArr = [];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      qrArr.push("\n");
      qrArr.push({
        qr: qrCode.qr + (qrCode?.appendInvoiceNo === true ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "left",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    var docDefinition = {
      pageSize: pageSize,
      pageOrientation: pageOrientation,
      watermark: {
        text: watermark.text,
        color: backgroundColor,
        opacity: Number(watermark.opacity),
        bold: false,
        italics: false,
      },
      info: {
        title: "Invoice No#" + obj.invoiceNo,
        author: "Invoice Generator",
        subject: "Invoice No#" + obj.invoiceNo,
        keywords: "Invoice No#" + obj.invoiceNo,
      },
      footer: function (currentPage, pageCount, pageSize) {
        return {
          text: `${reportDate} : Page ${currentPage.toString()} of ${pageCount.toString()}`,
          alignment: "center",
          fontSize: 8,
        };
      },
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 10,
                w: pageSize.width,
                h: 3,
                color: backgroundColor,
              },
            ],
          },
        ];
      },
      content: [
        {
          style: "section",
          columns: [
            {
              // fillColor: "#F9F9F9",
              width: "*",
              text: [
                {
                  text: obj.invoiceFrom,
                  fillColor: "#CCCCCC",
                },
              ],
            },
            {
              width: "auto",
              columns: [
                {
                  image: obj.imgSrc
                    ? obj.imgSrc
                    : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
                  width: 100,
                  height: 100,
                },
              ],
            },
            {
              text: [
                {
                  text: obj.invoiceTo,
                  alignment: "right",
                  backgroundColor: "#F9F9F9",
                },
              ],
            },
          ],
        },

        {
          columns: [
            {
              width: "*",
              text: [
                {
                  text: `${obj.title} #${obj.invoiceNo}`,
                  fontSize: 15,
                  bold: true,
                  lineHeight: 1.2,
                },
              ],
            },
            {
              text: "Invoice Date: " + obj.invoiceDate,
              alignment: "right",
            },
            {
              text: "Due Date: " + obj.dueDate,
              alignment: "right",
            },
          ],
        },

        "\n",
        {
          margin: [0, 0, 0, 0],
          layout: "exampleLayout",
          dontBreakRows: true,
          table: {
            headerRows: 1,
            widths: ["auto", "*", 50, 60, 30, 80],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
        },

        {
          columns: [
            {
              width: "*",
              stack: qrArr,
            },
            {
              width: "auto",
              columns: [
                {
                  layout: "totalLayout",
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 0,
                    widths: ["*", 80],

                    body: [
                      [
                        { text: "Subtotal", bold: true, alignment: "right" },
                        {
                          text: this.getSubtotal(obj.items),
                          bold: false,
                          alignment: "right",
                        },
                      ],
                      [
                        { text: "Discounts", bold: true, alignment: "right" },
                        {
                          text:
                            obj.discounts > 0
                              ? "-" + obj.discounts
                              : obj.discounts,
                          bold: false,
                          alignment: "right",
                        },
                      ],
                      [
                        { text: "Shipping", bold: true, alignment: "right" },
                        {
                          text: obj.shipping,
                          bold: false,
                          alignment: "right",
                        },
                      ],
                      [
                        {
                          text: "Total (" + (obj.currency || "USD") + ")",
                          bold: true,
                          alignment: "right",
                        },
                        {
                          text: this.getTotal(
                            obj.items,
                            obj.discounts,
                            obj.shipping
                          ),
                          bold: false,
                          alignment: "right",
                        },
                      ],
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          stack: [
            {
              text:
                obj.terms !== "" ? "\nTerms & Conditions\n" + obj.terms : "",
              fontSize: 10,
            },
            "\n\n\n\n",
            {
              canvas: [
                {
                  type: "line",
                  x1: 0,
                  y1: 5,
                  x2: 250,
                  y2: 5,
                  lineWidth: 1,
                },
              ],
            },
            { text: "Signature / Stamp", color: backgroundColor },
            { text: "Place: " },
            { text: "Date: " },
          ],
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        section: {
          // color: "#FFFFFF",
          fillColor: "#2361AE",
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5],
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "black",
        },
      },
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };

  // Template 5
  static generateDocDefTemplate5 = (obj) => {
    const {
      backgroundColor,
      watermark,
      pageSize,
      pageOrientation,
      qrCodeActive,
      qrCode,
    } = this.docDefinition;
    let itemBody = [
      [
        { text: "#", style: "tableHeader" },
        { text: "Item", style: "tableHeader" },
        { text: "Qty", style: "tableHeader", alignment: "center" },
        { text: "Rate", style: "tableHeader", alignment: "right" },
        {
          text: obj?.taxation ?? "GST",
          style: "tableHeader",
          alignment: "center",
        },
        { text: "Amount", style: "tableHeader", alignment: "right" },
      ],
    ];
    let itemArr = ["", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      itemBody.push([
        index + 1,
        handleArabicCharacters(element.title),
        { text: element.quantity, alignment: "center" },
        { text: element.rate, alignment: "right" },
        { text: element.taxationPer, alignment: "center" },
        { text: element.amount, alignment: "right" },
      ]);
    }
    let subTotalArr = [
      {
        width: "*",
        columns: [
          {
            width: "*",
            text: [
              {
                text: "Subtotal",
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: "Discounts",
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: "Shipping",
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 250,
                    y2: 5,
                    lineWidth: 3,
                  },
                ],
              },
              {
                text: "Total (" + (obj.currency || "USD") + ")",
                fontSize: 12,
                bold: true,
                alignment: "right",
              },
            ],
          },
          {
            width: "auto",
            text: [
              {
                text: this.getSubtotal(obj.items),
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: obj.discounts > 0 ? "-" + obj.discounts : obj.discounts,
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: obj.shipping,
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: this.getTotal(obj.items, obj.discounts, obj.shipping),
                fontSize: 12,
                bold: true,
                alignment: "right",
              },
            ],
          },
        ],
      },
    ];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      subTotalArr.push("\n\n");
      subTotalArr.push({
        qr: qrCode.qr + (qrCode?.appendInvoiceNo === true ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "right",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    var docDefinition = {
      pageSize: pageSize,
      pageOrientation: pageOrientation,
      watermark: {
        text: watermark.text,
        color: backgroundColor,
        opacity: Number(watermark.opacity),
        bold: false,
        italics: false,
      },
      info: {
        title: "Invoice No#" + obj.invoiceNo,
        author: "Invoice Generator",
        subject: "Invoice No#" + obj.invoiceNo,
        keywords: "Invoice No#" + obj.invoiceNo,
      },
      footer: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 0,
                w: pageSize.width,
                h: 5,
                color: backgroundColor,
              },
            ],
          },
          {
            table: {
              widths: ["80%", "20%"],
              body: [
                [
                  {
                    text: obj.footNote,
                    alignment: "left",
                    fontSize: 7,
                    margin: [40, 0, 0, 0],
                  },
                  {
                    text:
                      "Page " +
                      currentPage.toString() +
                      " of " +
                      pageCount +
                      "   ",
                    alignment: "right",
                    margin: [0, 10, 40, 0],
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
        ];
      },
      pageMargins: [40, 85, 40, 40],
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            table: {
              widths: ["50%", "50%"],
              body: [
                [
                  {
                    image: obj.imgSrc
                      ? obj.imgSrc
                      : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
                    width: 70,
                    height: 50,
                    margin: [40, 10, 0, 0],
                  },
                  {
                    margin: [40, 10, 40, 0],
                    text: [
                      {
                        text: `${obj.title} #${obj.invoiceNo}`,
                        fontSize: 15,
                        bold: true,
                        alignment: "right",
                        lineHeight: 1.2,
                      },
                      "\n",
                      {
                        text: "Invoice Date: " + obj.invoiceDate,
                        alignment: "right",
                      },
                      "\n",
                      {
                        text: "Due Date: " + obj.dueDate,
                        alignment: "right",
                      },
                    ],
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 0,
                w: pageSize.width,
                h: 5,
                color: backgroundColor,
              },
            ],
          },
        ];
      },
      content: [
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            // dontBreakRows: true,
            // keepWithHeaderRows: 1,
            body: [
              [
                { text: "Bill From", style: "tableHeader" },
                { text: "Bill For", style: "tableHeader" },
              ],
              [obj.invoiceFrom, obj.invoiceTo],
            ],
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "*", 50, 60, 30, 80],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
          layout: "lightHorizontalLines",
        },
        {
          columns: [
            {
              width: "70%",
              text: [
                {
                  text:
                    obj.terms !== "" ? "Terms & Conditions\n" + obj.terms : "",
                  fontSize: 10,
                },
              ],
            },
            subTotalArr,
          ],
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5],
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "black",
        },
      },
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };

  // Template 6
  static generateDocDefTemplate6 = (obj) => {
    const {
      backgroundColor,
      watermark,
      pageSize,
      pageOrientation,
      qrCodeActive,
      qrCode,
    } = this.docDefinition;
    let itemBody = [
      [
        { text: "#", style: "tableHeader" },
        { text: "Item", style: "tableHeader" },
        { text: "Qty", style: "tableHeader", alignment: "center" },
        { text: "Rate", style: "tableHeader", alignment: "right" },
        {
          text: obj?.taxation ?? "GST",
          style: "tableHeader",
          alignment: "center",
        },
        { text: "Amount", style: "tableHeader", alignment: "right" },
      ],
    ];
    let itemArr = ["", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      itemBody.push([
        index + 1,
        handleArabicCharacters(element.title),
        { text: element.quantity, alignment: "center" },
        { text: element.rate, alignment: "right" },
        { text: element.taxationPer, alignment: "center" },
        { text: element.amount, alignment: "right" },
      ]);
    }
    let subTotalArr = [
      {
        width: "*",
        columns: [
          {
            width: "*",
            text: [
              {
                text: "Subtotal",
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: "Discounts",
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: "Shipping",
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 250,
                    y2: 5,
                    lineWidth: 3,
                  },
                ],
              },
              {
                text: "Total (" + (obj.currency || "USD") + ")",
                fontSize: 12,
                bold: true,
                alignment: "right",
              },
            ],
          },
          {
            width: "auto",
            text: [
              {
                text: this.getSubtotal(obj.items),
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: obj.discounts > 0 ? "-" + obj.discounts : obj.discounts,
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: obj.shipping,
                alignment: "right",
                lineHeight: 1.2,
              },
              "\n",
              {
                text: this.getTotal(obj.items, obj.discounts, obj.shipping),
                fontSize: 12,
                bold: true,
                alignment: "right",
              },
            ],
          },
        ],
      },
    ];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      subTotalArr.push("\n\n");
      subTotalArr.push({
        qr: qrCode.qr + (qrCode?.appendInvoiceNo === true ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "right",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    pdfMake.tableLayouts = {
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 0;
          }
          return i === node.table.headerRows ? 2 : 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return i === 1 ? "black" : "#aaa";
        },
        fillColor: function (i, node) {
          return i === 0 ? backgroundColor : i % 2 === 0 ? "#CCCCCC" : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
    };
    var docDefinition = {
      pageSize: pageSize,
      pageOrientation: pageOrientation,
      watermark: {
        text: watermark.text,
        color: backgroundColor,
        opacity: Number(watermark.opacity),
        bold: false,
        italics: false,
      },
      info: {
        title: "Invoice No#" + obj.invoiceNo,
        author: "Invoice Generator",
        subject: "Invoice No#" + obj.invoiceNo,
        keywords: "Invoice No#" + obj.invoiceNo,
      },
      footer: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 0,
                w: pageSize.width,
                h: 5,
                color: backgroundColor,
              },
            ],
          },
          {
            table: {
              widths: ["80%", "20%"],
              body: [
                [
                  {
                    text: obj.footNote,
                    alignment: "left",
                    fontSize: 7,
                    margin: [40, 0, 0, 0],
                  },
                  {
                    text:
                      "Page " +
                      currentPage.toString() +
                      " of " +
                      pageCount +
                      "   ",
                    alignment: "right",
                    margin: [0, 10, 40, 0],
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
        ];
      },
      pageMargins: [40, 85, 40, 40],
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            table: {
              widths: ["20%", "40%", "40%"],
              body: [
                [
                  {
                    image: obj.imgSrc
                      ? obj.imgSrc
                      : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
                    width: 70,
                    height: 50,
                    margin: [40, 10, 0, 0],
                  },
                  {
                    margin: [10, 10, 10, 0],
                    text: obj.invoiceFrom,
                    fontSize: 10,
                  },
                  {
                    margin: [10, 10, 10, 0],
                    text: obj.invoiceTo,
                    fontSize: 10,
                    bold: true,
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 0,
                w: pageSize.width,
                h: 5,
                color: backgroundColor,
              },
            ],
          },
        ];
      },
      content: [
        {
          columns: [
            {
              width: "*",
              text: [
                {
                  text: `${obj.title} #${obj.invoiceNo}`,
                  fontSize: 15,
                  bold: true,
                  lineHeight: 1.2,
                },
              ],
            },
            {
              text: "Invoice Date: " + obj.invoiceDate,
              alignment: "right",
            },
            {
              text: "Due Date: " + obj.dueDate,
              alignment: "right",
              decoration: "underline",
            },
          ],
        },
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "*", 50, 60, 30, 80],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
          layout: "exampleLayout",
        },
        {
          columns: [
            {
              width: "70%",
              text: [
                {
                  text:
                    obj.terms !== "" ? "Terms & Conditions\n" + obj.terms : "",
                  fontSize: 10,
                },
              ],
            },
            subTotalArr,
          ],
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5],
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "white",
        },
      },
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };

  // Template 7
  static generateDocDefTemplate7 = (obj) => {
    const { pageSize, pageOrientation, qrCodeActive, qrCode } =
      this.docDefinition;
    const { backgroundColor, watermark, columns, headerSettings } =
      this.bill4Settings;
    let itemHeader = [
      { text: "#", style: "tableHeader", alignment: "right", color: "white" },
    ];
    let itemWidths = [15];

    if (columns.barcode?.isVisible) {
      itemHeader.push({
        text: [
          {
            text: reverseArabicAndEnglish(columns?.barcode?.nameAr) + " \n ",
            style: "tableHeader",
            color: "white",
            fontSize: 8,
            font: "DroidKufiRegular",
          },
          {
            text: obj?.columns.barcode.nameEn,
            style: "tableHeader",
            color: "white",
          },
        ],
      });
      itemWidths.push("auto");
    }
    if (columns.colmProductDesc?.isVisible) {
      itemHeader.push({
        text: [
          {
            text:
              reverseArabicAndEnglish(columns?.colmProductDesc?.nameAr) +
              " \n ",
            style: "tableHeader",
            color: "white",
            fontSize: 8,
            font: "DroidKufiRegular",
          },
          {
            text: obj?.columns.colmProductDesc.nameEn,
            style: "tableHeader",
            color: "white",
          },
        ],
      });
      itemWidths.push("*");
    }

    if (columns.colmUnit?.isVisible) {
      itemHeader.push({
        text: [
          {
            text:
              reverseArabicAndEnglish(obj?.columns?.colmUnit?.nameAr) + "\n ",
            style: "tableHeader",
            color: "white",
            fontSize: 8,
            alignment: "center",
            font: "DroidKufiRegular",
          },
          {
            text: columns.colmUnit?.nameEn,
            alignment: "center",
            style: "tableHeader",
            color: "white",
          },
        ],
      });
      itemWidths.push("auto");
    }

    if (columns.colmQty?.isVisible) {
      itemHeader.push({
        text: [
          {
            text: reverseArabicAndEnglish(obj?.columns.colmQty.nameAr) + "\n ",
            style: "tableHeader",
            color: "white",
            fontSize: 8,
            alignment: "center",
            font: "DroidKufiRegular",
          },
          {
            text: columns.colmQty?.nameEn,
            alignment: "center",
            style: "tableHeader",
            color: "white",
          },
        ],
      });
      itemWidths.push("auto");
    }

    if (columns.colmUnitPrice?.isVisible) {
      itemHeader.push({
        text: [
          {
            text: reverseArabicAndEnglish(columns.colmUnitPrice?.nameAr) + "\n",
            style: "tableHeader",
            color: "white",
            fontSize: 8,
            alignment: "center",
            font: "DroidKufiRegular",
          },
          {
            text: columns.colmUnitPrice?.nameEn,
            alignment: "center",
            style: "tableHeader",
            color: "white",
          },
        ],
      });
      itemWidths.push("auto");
    }

    if (columns.colmDiscount?.isVisible) {
      itemHeader.push({
        text: [
          {
            text: reverseArabicAndEnglish(columns.colmDiscount?.nameAr) + "\n ",
            style: "tableHeader",
            color: "white",
            fontSize: 8,
            alignment: "center",
            font: "DroidKufiRegular",
          },
          {
            text: columns.colmDiscount?.nameEn,
            alignment: "center",
            style: "tableHeader",
            color: "white",
          },
        ],
      });
      itemWidths.push("auto");
    }
    if (columns.colmTax?.isVisible) {
      itemHeader.push({
        text: [
          {
            text: reverseArabicAndEnglish(columns.colmTax?.nameAr) + "\n",
            style: "tableHeader",
            color: "white",
            fontSize: 8,
            alignment: "center",
            font: "DroidKufiRegular",
          },
          {
            text: columns.colmTax?.nameEn,
            alignment: "center",
            style: "tableHeader",
            color: "white",
          },
        ],
      });
      itemWidths.push("auto");
    }

    itemHeader.push({
      text: [
        {
          text: reverseArabicAndEnglish("الإجمالي مع الضريبة ") + "\n",
          style: "tableHeader",
          color: "white",
          fontSize: 8,
          alignment: "center",
          font: "DroidKufiRegular",
        },
        {
          text: "Amount with Vat",
          alignment: "center",
          style: "tableHeader",
          color: "white",
        },
      ],
    });
    itemWidths.push("auto");
    let itemBody = [itemHeader];
    let itemArr = ["", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      const propName = `${columns.colmProductDesc?.fieldName?.toString()}`;
      console.log("the item is", propName);
      let itemRow = [{ text: index + 1, alignment: "right" }];
      if (columns.barcode?.isVisible)
        itemRow.push({
          text: element[
            `${columns.barcode?.fieldName?.toString() ?? "barcode"}`
          ],
          alignment: "center",
        });
      if (columns.colmProductDesc?.isVisible)
        itemRow.push({
          text: [...handleArabicCharacters(element[propName])],
          alignment: "right",
          fontSize: 11,
        });
      if (columns.colmUnit?.isVisible)
        itemRow.push({
          text: element[
            `${columns.colmUnit?.fieldName?.toString() ?? "unit_name"}`
          ],
          alignment: "center",
        });
      if (columns.colmQty?.isVisible)
        itemRow.push({
          text: element[`${columns.colmQty?.fieldName?.toString() ?? "val1"}`],
          alignment: "right",
        });
      if (columns.colmUnitPrice?.isVisible)
        itemRow.push({
          text: element[
            `${columns.colmUnitPrice?.fieldName?.toString() ??
            "new_exchange_price"
            }`
          ],
          alignment: "center",
        });
      if (columns.colmDiscount?.isVisible)
        itemRow.push({
          text: element[
            `${columns.colmDiscount?.fieldName?.toString() ?? "discount"}`
          ],
          alignment: "right",
        });
      if (columns.colmTax?.isVisible)
        itemRow.push({
          text: element[
            `${columns.colmTax?.fieldName?.toString() ?? "new_taxval"}`
          ],
          alignment: "center",
        });
      itemRow.push({ text: element?.tot_net_curr, alignment: "center" });
      itemBody.push(itemRow);
    }

    pdfMake.tableLayouts = {
      totalLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#aaa";
        },
        fillColor: function (i, node) {
          // return i === 0 ? "#e8e8e8" : i % 2 === 0 ? "#e8e8e8" : null;
          return i === 3 ? backgroundColor : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 1;
          }
          return i === node.table.headerRows ? 2 : 1;
        },
        vLineWidth: function (i) {
          return 1;
        },
        hLineColor: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return "black";
          }
          return i === 1 ? "black" : "#aaa";
        },
        fillColor: function (i, node) {
          return i === 0 ? backgroundColor : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
    };
    // -- Set the report date for display only.
    let reportDate = new Date().toDateString();
    let qrArr = [];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      qrArr.push("\n");
      qrArr.push({
        qr: qrCode.qr + (qrCode?.appendInvoiceNo === true ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "left",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    var docDefinition = {
      pageSize: pageSize,
      pageOrientation: pageOrientation,
      watermark: {
        text: watermark.text,
        color: backgroundColor,
        opacity: Number(watermark.opacity),
        bold: false,
        italics: false,
      },
      info: {
        title: "Invoice No#" + obj.invoiceNo,
        author: "Invoice Generator",
        subject: "Invoice No#" + obj.invoiceNo,
        keywords: "Invoice No#" + obj.invoiceNo,
      },

      footer: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 0,
                w: pageSize.width,
                h: 2,
                color: backgroundColor,
              },
            ],
          },
          {
            table: {
              widths: ["80%", "20%"],
              body: [
                [
                  {
                    text: reverseArabicAndEnglish(obj.footNote),
                    alignment: "left",
                    fontSize: 9,
                    margin: [40, 0, 0, 0],
                  },
                  {
                    text:
                      "Page " +
                      currentPage.toString() +
                      " of " +
                      pageCount +
                      "   ",
                    alignment: "right",
                    margin: [0, 10, 40, 0],
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
        ];
      },
      pageMargins: [40, headerSettings.height ?? 0, 40, 40],
      header: function (currentPage, pageCount, pageSize) {
        if (headerSettings.isVisible)
          return [
            {
              columns: [
                {
                  width: "*",
                  margin: [30, 10, 0, 0],
                  stack: [
                    {
                      // text: obj.invoiceFrom,
                      text: obj?.found?.Disc1_header_en + "\n",
                    },

                    {
                      text:
                        obj?.found?.Disc2_header_en &&
                        obj?.found?.Disc2_header_en + "\n",
                    },
                    {
                      text:
                        obj?.found?.Disc3_header_en &&
                        obj?.found?.Disc3_header_en + "\n",
                    },
                    {
                      text:
                        obj?.found?.Disc4_header_en &&
                        obj?.found?.Disc4_header_en + "\n",
                    },
                  ],
                },
                {
                  width: "auto",
                  margin: [0, 10, 0, 0],

                  columns: [
                    {
                      image: obj.imgSrc
                        ? obj.imgSrc
                        : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
                      width: 80,
                      height: 80,
                      alignment: "center",
                    },
                  ],
                },
                {
                  margin: [0, 10, 30, 0],
                  stack: [
                    {
                      // obj.invoiceTo,
                      text:
                        reverseArabicAndEnglish(obj?.found?.Disc1_header_ar) +
                        "\n",
                      alignment: "right",
                      font: "DroidKufiRegular",
                    },

                    {
                      // obj.invoiceTo,
                      text:
                        obj?.found?.Disc2_header_ar &&
                        reverseArabicAndEnglish(obj?.found?.Disc2_header_ar) +
                        "\n",
                      alignment: "right",
                      // font: "DroidKufiRegul//ar",
                    },

                    {
                      // obj.invoiceTo,
                      text:
                        obj?.found?.Disc3_header_ar &&
                        reverseArabicAndEnglish(obj?.found?.Disc3_header_ar) +
                        "\n",
                      alignment: "right",
                      // font: "DroidKufiRegular",
                    },
                    {
                      // obj.invoiceTo,
                      text:
                        obj?.found?.Disc4_header_ar &&
                        reverseArabicAndEnglish(obj?.found?.Disc4_header_ar) +
                        "\n",
                      alignment: "right",
                      // font: "DroidKufiRegular",
                    },
                  ],
                },
              ],
              // canvas: [
              //   {
              //     type: "rect",
              //     x: 0,
              //     y: 10,
              //     w: pageSize.width,
              //     h: 3,
              //     color: backgroundColor,
              //   },
              // ],
            },
          ];

        return [
          // {
          //   canvas: [
          //     {
          //       type: "rect",
          //       x: 0,
          //       y: 10,
          //       w: pageSize.width,
          //       h: 3,
          //       color: backgroundColor,
          //     },
          //   ],
          // },
        ];
      },
      content: [
        "\n",
        {
          columns: [
            {
              width: "*",
              text: [
                {
                  text: `${obj.title} #${obj?.tot?.id}`,
                  fontSize: 15,
                  bold: true,
                  lineHeight: 1,
                },
              ],
            },
            {
              text:
                obj?.tot?.tax_no_cust === ""
                  ? reverseArabicAndEnglish("فاتورة ضريبية مبسطة")
                  : reverseArabicAndEnglish("فاتورة ضريبية"),
              alignment: "center",
              font: "DroidKufiRegular",
            },
            {
              text: "Date: " + moment(obj?.tot?.date).format("YYYY-MM-DD"),
              alignment: "right",
            },
          ],
        },

        {
          columns: [
            {
              width: "*",
              text: [
                {
                  text: `Ref No: #${obj?.tot?.refno}`,
                  fontSize: 14,
                  bold: true,
                  lineHeight: 1.2,
                },
              ],
            },
            {
              text: reverseArabicAndEnglish(
                obj?.locInv?.invN +
                " " +
                (!obj?.premiApp?.hidePayType
                  ? obj?.tot?.inv_type_name + "" + obj?.tot?.pay_type_name
                  : "") +
                (obj?.premiApp?.hidePayType &&
                  obj?.tot?.inv_type_name == "نقدية"
                  ? obj?.tot?.inv_type_name
                  : "")
              ),
              fontSize: 12,
              alignment: "center",
              font: "DroidKufiRegular",
            },
            {
              text: "Time: " + moment(obj?.tot?.date).format(" h:mm A"),
              alignment: "right",
            },
          ],
        },
        {
          style: "tableExample",
          color: "#555",
          // layout: "lightHorizontalLines", // optional
          layout: {
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === node.table.body.length
                ? "white"
                : "white";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "white"
                : "white";
            },
          },
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ["30%", "*", "30%"],

            body: [
              [
                {
                  text: "Customer Details",
                  bold: true,
                  fillColor: backgroundColor,
                  color: "#ffffff",
                },
                { text: "", bold: true, fillColor: backgroundColor },
                {
                  text: reverseArabicAndEnglish("بيانات العميل"),
                  bold: true,
                  fillColor: backgroundColor,
                  alignment: "right",
                  color: "#ffffff",
                },
              ],
              [
                { text: "Customer Name" },
                {
                  text: reverseArabicAndEnglish(obj?.tot?.cust_name),
                  bold: true,
                  fillColor: "#F9F9F9",
                  alignment: "center",
                },
                {
                  text: reverseArabicAndEnglish("اسم العميل"),
                  alignment: "right",
                },
              ],
              [
                { text: "Address" },
                {
                  text: reverseArabicAndEnglish(obj?.tot?.cust_address),
                  bold: true,
                  fillColor: "#F9F9F9",
                  alignment: "center",
                },
                {
                  text: reverseArabicAndEnglish("عنوان العميل"),
                  alignment: "right",
                },
              ],
              [
                { text: "Vat Id" },
                {
                  text: reverseArabicAndEnglish(obj?.tot?.tax_no_cust),
                  bold: true,
                  fillColor: "#F9F9F9",
                  alignment: "center",
                },
                {
                  text: reverseArabicAndEnglish("الرقم الضريبي"),
                  alignment: "right",
                },
              ],
            ],
          },
        },
        // "\n",
        {
          margin: [0, 0, 0, 0],
          layout: "exampleLayout",
          dontBreakRows: true,
          table: {
            headerRows: 1,
            widths: itemWidths,
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
        },
        {
          id: "totalsData",
          headlineLevel: 1,
          columns: [
            {
              // width: "*",
              image: `data:image/jpeg;base64,${obj?.inv?.qr_image}`,
              height: 100,
              width: 100,
              // stack: qrArr,
            },
            {
              width: "*",
              columns: [
                {
                  layout: "totalLayout",
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 0,
                    widths: ["*", 90],
                    dontBreakRows: true,
                    body: [
                      [
                        {
                          text:
                            "Total Amount" +
                            " " +
                            reverseArabicAndEnglish("الإجمالي"),
                          bold: true,

                          alignment: "right",
                        },
                        {
                          text: this.getTotalAmount(obj?.tot),
                          bold: false,
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text:
                            "Discount" + " " + reverseArabicAndEnglish("الخصم"),
                          bold: true,
                          alignment: "right",
                        },
                        {
                          text: obj?.tot?.discount?.toFixed(2),
                          bold: false,
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text:
                            "Total Vat" +
                            " " +
                            reverseArabicAndEnglish(
                              "مجموع ضريبة القيمة المضافة"
                            ),
                          bold: true,
                          alignment: "right",
                        },
                        {
                          text: obj?.tot?.amountOfVat?.toFixed(2),
                          bold: false,
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text:
                            "Total Amount With Vat" +
                            " " +
                            reverseArabicAndEnglish("الإجمالي مع الضريبة "),
                          bold: true,
                          alignment: "right",
                        },
                        {
                          text: obj?.tot?.tot_net?.toFixed(2),
                          bold: true,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
              ],
            },
          ],
        },

        {
          columns: [
            {
              layout: "lightHorizontalLines",
              table: {
                // headers are automatically repeated if the table spans over multiple pages
                // you can declare how many rows should be treated as headers
                headerRows: 0,
                widths: [70, 70, 70, 70, 70, 70],
                body: [
                  [
                    {
                      text: reverseArabicAndEnglish("المتبقي"),

                      fontSize: 9,
                      bold: true,
                      font: "DroidKufiRegular",
                      alignment: "right",
                    },
                    {

                      text:
                        obj?.tot?.inv_type_name == "نقدية"
                          ? 0
                          : obj?.tot?.tot_net?.toFixed(2) - obj?.tot?.paid,
                      bold: false,
                      alignment: "left",
                    },
                    {
                      text: reverseArabicAndEnglish("المدفوع"),
                      bold: true,
                      fontSize: 9,

                      font: "DroidKufiRegular",
                      alignment: "right",
                    },
                    {
                      text:
                        obj?.tot?.inv_type_name == "نقدية"
                          ? obj?.tot?.tot_net?.toFixed(2)
                          : obj?.tot?.paid,
                      bold: false,
                      alignment: "left",
                    },

                    {
                      text: reverseArabicAndEnglish("إجمالي الكمية"),
                      font: "DroidKufiRegular",
                      fontSize: 9,
                      alignment: "right",
                    },
                    {
                      text: this.getQtyTotal(obj?.items),
                      bold: false,
                      alignment: "left",
                    },
                  ],
                ],
              },
            },
          ],
        },
        {
          stack: [
            {
              text:
                obj.terms !== ""
                  ? "ملاحظات\n" + reverseArabicAndEnglish(obj?.terms)
                  : "",
              fontSize: 10,
              alignment: "right",
            },
            "\n",
            {
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      text: "Signature /" + sto?.usernames,
                      alignment: "left",
                      color: backgroundColor,
                      // fontSize: 9,
                      // margin: [40, 0, 0, 0],
                    },
                    {
                      text: "Reciver ",
                      alignment: "right",
                      // margin: [0, 10, 40, 0],
                    },
                  ],
                ],
              },
              layout: "noBorders",
            },
            // { text: "Signature /" + sto?.usernames, color: backgroundColor },
            // { text: "Reciver: " },
            // { text: "Date: " },
          ],
        },
      ],
      pageBreakBefore: function (
        currentNode,
        followingNodesOnPage,
        nodesOnNextPage,
        previousNodesOnPage
      ) {
        return (
          currentNode.headlineLevel == 1 &&
          currentNode?.pages != currentNode?.pageNumbers[0]
        );
      },
      styles: {
        header: {
          fontSize: 15,
          bold: true,
          margin: [0, 10, 0, 10],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5],
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "black",
        },
      },
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };

  // Template 8
  static generateDocDefTemplate88 = (obj) => {
    const { pageSize, pageOrientation, qrCodeActive, qrCode } =
      this.docDefinition;
    const { backgroundColor, watermark, columns, headerSettings } =
      this.bill4Settings;
    let itemHeader = [
      {
        text: reverseArabicAndEnglish("اسم الصنف"),
        style: "tableHeader",
        alignment: "right",
        fontSize: "1.5rem",
        bold: true,
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("الكمية"),
        style: "tableHeader",
        alignment: "center",
        bold: true,
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("السعر"),
        style: "tableHeader",
        alignment: "center",
        bold: true,
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("الإجمالي"),
        style: "tableHeader",
        fontSize: 8,
        alignment: "center",
        font: "DroidKufiRegular",
      },
    ];

    let itemWidths = [15, "auto", "auto", "*"];

    // itemWidths.push("auto");
    let itemBody = [itemHeader];
    let itemArr = ["", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      const propName = `${columns.colmProductDesc?.fieldName?.toString()}`;
      console.log("the item is", propName);
      let itemRow = [];
      itemRow.push({
        text: [...handleArabicCharacters(element["symbol"])],
        alignment: "right",
        fontSize: 10,
      });
      itemRow.push({
        text: element["val1"],
        alignment: "right",
      });
      itemRow.push({
        text: element["new_exchange_price"],
        alignment: "center",
      });

      itemRow.push({ text: element["tot_net_curr"], alignment: "center" });
      itemBody.push(itemRow);
    }

    pdfMake.tableLayouts = {
      totalLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#aaa";
        },
        fillColor: function (i, node) {
          // return i === 0 ? "#e8e8e8" : i % 2 === 0 ? "#e8e8e8" : null;
          return i === 3 ? backgroundColor : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 1;
          }
          return i === node.table.headerRows ? 2 : 1;
        },
        vLineWidth: function (i) {
          return 1;
        },
        hLineColor: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return "black";
          }
          return i === 1 ? "black" : "#aaa";
        },
        // fillColor: function (i, node) {
        //   return i === 0 ? backgroundColor : null;
        // },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
    };
    // -- Set the report date for display only.

    let qrArr = [];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      qrArr.push("\n");
      qrArr.push({
        qr:
          qrCode.qr + (qrCode?.appendInvoiceNo === false ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "left",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    var docDefinition = {
      pageSize: { width: 260, height: "auto" },
      pageOrientation: pageOrientation,

      content: [
        {
          image: obj.imgSrc
            ? obj.imgSrc
            : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
          width: 80,
          height: 80,
          alignment: "center",
        },
        {
          text: reverseArabicAndEnglish(obj?.found?.nameA),
          alignment: "center",
          font: "DroidKufiRegular",
          fontSize: 12,
          bold: true,
          margin: [0, 1],
        },
        {
          text: "Phone No: " + reverseArabicAndEnglish(obj?.found?.Mobile),
          alignment: "center",
          fontSize: 10,
          // margin: [0, 5],
        },
        {
          text: "VAT# " + reverseArabicAndEnglish(obj?.found?.tax_no),
          alignment: "center",
          font: "DroidKufiRegular",
          fontSize: 10,
          bold: true,
          // margin: [0, 5],
        },
        {
          text: obj?.tot?.id,
          fontSize: 14,
          bold: true,
          lineHeight: 1,
          font: "DroidKufiRegular",
          alignment: "center",
        },
        {
          text:
            obj?.tot?.tax_no_cust === ""
              ? reverseArabicAndEnglish("فاتورة ضريبية مبسطة")
              : reverseArabicAndEnglish("فاتورة ضريبية"),
          alignment: "center",
          font: "DroidKufiRegular",
          fontSize: 10,
          bold: true,
        },
        {
          text: reverseArabicAndEnglish(
            obj?.locInv?.invN +
            " " +
            (!obj?.premiApp?.hidePayType
              ? obj?.tot?.inv_type_name + "" + obj?.tot?.pay_type_name
              : "") +
            (obj?.premiApp?.hidePayType && obj?.tot?.inv_type_name == "نقدية"
              ? obj?.tot?.inv_type_name
              : "")
          ),
          fontSize: 10,
          bold: true,
          alignment: "center",
          font: "DroidKufiRegular",
        },

        {
          text: "customer: " + reverseArabicAndEnglish(obj?.tot?.cust_name),
          fontSize: 10,
          alignment: "left",
          font: "DroidKufiRegular",
          bold: true,
          // font: "DroidKufiRegular",
        },
        {
          text: "Date: " + moment(obj?.tot?.date).format("YYYY-MM-DD,h:mm"),
          alignment: "right",
          fontSize: 10,
          font: "DroidKufiRegular",
          bold: true,
        },
        // "\n",
        {
          margin: [0, 0, 0, 0],
          layout: "exampleLayout",
          dontBreakRows: true,
          table: {
            headerRows: 1,
            widths: ["*", "auto", "auto", "auto"],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
        },
        {
          layout: "totalLayout",
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 0,
            widths: ["*", 90],
            dontBreakRows: true,
            body: [
              [
                {
                  text: reverseArabicAndEnglish("الإجمالي"),
                  bold: true,
                  alignment: "right",
                  fontSize: 14,
                },
                {
                  text: this.getTotalAmount(obj?.tot),
                  bold: false,
                  alignment: "center",
                  fontSize: 14,
                },
              ],
              [
                {
                  text: reverseArabicAndEnglish("الخصم"),
                  bold: true,
                  alignment: "right",
                  fontSize: 14,
                },
                {
                  text: obj?.tot?.discount?.toFixed(2),
                  bold: false,
                  alignment: "center",
                  fontSize: 14,
                },
              ],
              // obj?.tot?.tab3Vat>0&&
              // [
              //   {
              //     text: reverseArabicAndEnglish("ضريبة التبغ"),
              //     bold: true,
              //     alignment: "right",
              //     fontSize: 14,
              //   },
              //   {
              //     text: obj?.tot?.tab3Vat?.toFixed(2),
              //     bold: false,
              //     alignment: "center",
              //     fontSize: 14,
              //   },
              // ],
              [
                {
                  text: reverseArabicAndEnglish("مجموع ضريبة القيمة المضافة"),
                  bold: true,
                  alignment: "right",
                },
                {
                  text: obj?.tot?.amountOfVat?.toFixed(2),
                  bold: false,
                  alignment: "center",
                  fontSize: 14,
                },
              ],
              [
                {
                  text: reverseArabicAndEnglish("الإجمالي مع الضريبة "),
                  bold: true,
                  alignment: "right",
                  fontSize: 14,
                },
                {
                  text: obj?.tot?.tot_net?.toFixed(2),
                  bold: true,
                  alignment: "center",
                  fontSize: 14,
                },
              ],
            ],
          },
        },
        {
          // width: "*",
          image: `data:image/jpeg;base64,${obj?.inv?.qr_image}`,
          height: 100,
          width: 100,
          // stack: qrArr,
        },

        // {
        //   columns: [
        //     {
        //       layout: "lightHorizontalLines",
        //       table: {
        //         // headers are automatically repeated if the table spans over multiple pages
        //         // you can declare how many rows should be treated as headers
        //         headerRows: 0,
        //         widths: [70, 70, 70, 70, 70, 70],
        //         body: [
        //           [
        //             {
        //               text: reverseArabicAndEnglish("المتبقي"),

        //               fontSize: 9,
        //               bold: true,
        //               font: "DroidKufiRegular",
        //               alignment: "right",
        //             },
        //             {
        //               text:
        //                 obj?.tot?.inv_type_name == "نقدية"
        //                   ? 0
        //                   : obj?.tot?.tot_net?.toFixed(2) - obj?.tot?.paid,
        //               bold: false,
        //               alignment: "left",
        //             },
        //             {
        //               text: reverseArabicAndEnglish("المدفوع"),
        //               bold: true,
        //               fontSize: 9,

        //               font: "DroidKufiRegular",
        //               alignment: "right",
        //             },
        //             {
        //               text:
        //                 obj?.tot?.inv_type_name == "نقدية"
        //                   ? obj?.tot?.tot_net?.toFixed(2)
        //                   : obj?.tot?.paid,
        //               bold: false,
        //               alignment: "left",
        //             },

        //             {
        //               text: reverseArabicAndEnglish("إجمالي الكمية"),
        //               font: "DroidKufiRegular",
        //               fontSize: 9,
        //               alignment: "right",
        //             },
        //             {
        //               text: this.getQtyTotal(obj?.items),
        //               bold: false,
        //               alignment: "left",
        //             },
        //           ],
        //         ],
        //       },
        //     },
        //   ],
        // },
        // {
        //   stack: [
        //     {
        //       text:
        //         obj.terms !== ""
        //           ? "ملاحظات\n" + reverseArabicAndEnglish(obj?.terms)
        //           : "",
        //       fontSize: 10,
        //       alignment: "right",
        //     },
        //     "\n",
        //   ],
        // },
      ],
      styles: {

        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 8,
          color: "black",
        },
      },

      pageMargins: [10, 10, 10, 10],
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };

  static generateDocDefTempelteCashair = (obj) => {
    const { pageSize, pageOrientation, qrCodeActive, qrCode } =
      this.docDefinition;
    const { backgroundColor, watermark, columns, headerSettings } =
      this.bill4Settings;
    let itemHeader = [
      {
        text: reverseArabicAndEnglish("الإجمالي"),
        style: "tableHeader",
        fontSize: 8,
        alignment: "center",
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("السعر"),
        style: "tableHeader",
        alignment: "center",
        bold: true,
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("الكمية"),
        style: "tableHeader",
        alignment: "center",
        bold: true,
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("اسم الصنف"),
        style: "tableHeader",
        alignment: "right",
        bold: true,
        font: "DroidKufiRegular",
      },
    ];
    let itemBody = [itemHeader];
    let itemArr = ["", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      const propName = `${columns.colmProductDesc?.fieldName?.toString()}`;
      // console.log("the item is", propName);
      let itemRow = [];
      itemRow.push({ text: element["tot_net_curr"], alignment: "center", fontSize: 16, });
      itemRow.push({
        text: element["new_exchange_price"],
        alignment: "center",
        fontSize: 16,
      });

      itemRow.push({
        text: element["val1"],
        alignment: "right",
        fontSize: 16,
      });
      itemRow.push({
        // text: [...handleArabicCharacters(element["symbol"])],
        text: prepareBillNotes(element["symbol"], 22),
        font: "CairoBold",
        alignment: "right",
        fontSize: 10,
      });
      itemBody.push(itemRow);
    }

    pdfMake.tableLayouts = {
      totalLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#aaa";
        },
        fillColor: function (i, node) {
          return i === 3 ? backgroundColor : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          return 3;
        },
        paddingTop: function (i, node) {
          return 1;
        },
        paddingBottom: function (i, node) {
          return 1;
        },
      },
      totalPLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#fff";
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          return 0;
        },
        paddingTop: function (i, node) {
          return 0;
        },
        paddingBottom: function (i, node) {
          return 0;
        },
      },
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 1;
          }
          return i === node.table.headerRows ? 2 : 1;
        },
        vLineWidth: function (i) {
          return 1;
        },
        hLineColor: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return "black";
          }
          return i === 1 ? "black" : "#aaa";
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          return 1;
        },
        paddingTop: function (i, node) {
          return 1;
        },
        paddingBottom: function (i, node) {
          return 1;
        },
      },
    };
    // -- Set the report date for display only.

    let qrArr = [];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      qrArr.push("\n");
      qrArr.push({
        qr:
          qrCode.qr + (qrCode?.appendInvoiceNo === false ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "left",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    var docDefinition = {
      pageSize: { width: 260, height: "auto" },
      pageOrientation: pageOrientation,

      content: [
        {
          image: obj.imgSrc
            ? obj.imgSrc
            : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
          width: 80,
          height: 80,
          alignment: "center",
        },
        {
          // text: reverseArabicAndEnglish(obj?.found?.nameA),
          text: prepareBillNotes(obj?.found?.nameA, 42),
          font: "CairoBold",
          alignment: "center",
          // font: "DroidKufiRegular",
          fontSize: 11,
          bold: true,
          margin: [0, 1],
        },

        {
          // text: reverseArabicAndEnglish(obj?.found?.Address),
          text: prepareBillNotes(obj?.found?.Address, 42),
          font: "CairoBold",
          alignment: "center",
          fontSize: 11,
          bold: true,
          margin: [0, 1],
        },
        {
          text: "Phone No: " + reverseArabicAndEnglish(obj?.found?.Mobile),
          alignment: "center",
          font: "CairoBold",
          fontSize: 12,
          bold: true,
          margin: [0, 0],
        },
        {
          text: reverseArabicAndEnglish(obj?.found?.tax_no) + reverseArabicAndEnglish("الرقم الضريبي "),
          alignment: "center",
          font: "CairoBold",
          fontSize: 12,
          bold: true,
        },
        {
          text: reverseArabicAndEnglish(obj?.found?.bsn_no) + reverseArabicAndEnglish(" السجل التجاري  "),
          alignment: "center",
          font: "CairoBold",
          // font: "DroidKufiRegular",
          fontSize: 12,
          bold: true,
        },

        {
          layout: "totalLayout",
          table: {
            headerRows: 0,
            widths: ["*", 80],
            dontBreakRows: true,
            body: [
              [

                {
                  text: obj?.tot?.id,
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 12,
                  bold: true,
                  margin: [0, 0],
                },
                {
                  text: reverseArabicAndEnglish("رقم الفاتورة"),
                  bold: true,
                  alignment: "right",
                  // fontSize: 11,
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 10,
                },
              ],
              [

                {
                  text: moment(obj?.tot?.date).format("YYYY-MM-DD"),
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 12,
                  bold: true,
                  margin: [0, 0],

                },
                {
                  text: reverseArabicAndEnglish("تاريخ الفاتورة"),
                  bold: true,
                  alignment: "right",
                  // fontSize: 11,
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 10,
                },
              ],
              [
                {
                  text: prepareBillNotes(obj?.tot?.cust_name, 23),
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0],
                },
                {
                  text: reverseArabicAndEnglish("اسم العميل"),
                  bold: true,
                  alignment: "right",
                  font: "CairoBold",
                  fontSize: 10,
                  margin: [0, 0],
                  // font: "DroidKufiRegular",
                },
              ],
              [
                {
                  text: reverseArabicAndEnglish(obj?.tot?.tax_no_cust),
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 12,
                  bold: true,
                  margin: [0, 0],

                },
                {
                  text: reverseArabicAndEnglish("الرقم الضريبي"),
                  bold: true,
                  alignment: "right",
                  // fontSize: 10,
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 10,
                },
              ],
            ],
          },
        },


        {
          text:
            obj?.tot?.tax_no_cust === ""
              ? reverseArabicAndEnglish("فاتورة ضريبية مبسطة")
              : reverseArabicAndEnglish("فاتورة ضريبية"),
          alignment: "center",
          font: "DroidKufiRegular",
          fontSize: 11,
          bold: true,
        },
        {
          text: reverseArabicAndEnglish(
            obj?.locInv?.invN +
            " " +
            obj?.tot?.pay_type_name
          ),
          alignment: "center",
          font: "DroidKufiRegular",
          fontSize: 11,
          bold: true,
          // margin: [0, 1],
        },
        {
          margin: [0, 0, 0, 0],
          layout: "exampleLayout",
          dontBreakRows: true,
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "auto", "*"],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
        },
        {
          layout: "totalLayout",
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 0,
            widths: [90, "*"],
            // widths: ["*", 90],
            dontBreakRows: true,
            body: [
              [

                {
                  // text: this.getTotalAmount(obj?.tot),
                  text: ((obj?.tot?.tot_net - obj?.tot?.amountOfVat + obj?.tot?.discount) - parseFloat(obj?.tot?.tab3Vat ?? 0))?.toFixed(2),
                  // font: "DroidKufiRegular",
                  fontSize: 15,
                  bold: true,
                  // margin: [0, 1],
                  alignment: "center",
                },
                {
                  text: reverseArabicAndEnglish("الاجمالي قبل الضريبة"),
                  font: "DroidKufiRegular",
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0],
                  alignment: "right",
                },
              ],
              [
                {
                  text: obj?.tot?.discount?.toFixed(2),
                  // font: "DroidKufiRegular",
                  fontSize: 14,
                  bold: true,
                  margin: [0, 0],
                  alignment: "center",
                },
                {
                  // text: reverseArabicAndEnglish("الخصم"),
                  text: reverseArabicAndEnglish(" مجموع الخصومات"),
                  font: "DroidKufiRegular",
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0],
                  alignment: "right",
                },

              ],
              [
                {
                  text: obj?.tot?.amountOfVat?.toFixed(2),
                  // font: "DroidKufiRegular",
                  fontSize: 15,
                  bold: true,
                  margin: [0, 0],
                  alignment: "center",
                },
                {
                  text: "(15%)" + reverseArabicAndEnglish("إجمالي الضريبة"),
                  font: "NotoSimiBold",
                  fontSize: 11,
                  bold: true,
                  margin: [0, 0],
                  alignment: "right",
                },

              ],
              [obj?.tot?.tab3Vat > 0 ? {
                text: obj?.tot?.tab3Vat?.toFixed(2),
                // font: "DroidKufiRegular",
                fontSize: 15,
                bold: true,
                // margin: [0, 1],
                alignment: "center",
              } : {},
              obj?.tot?.tab3Vat > 0 ? {
                text: "%100" + reverseArabicAndEnglish("مجموع ضريبة التبغ"),
                font: "NotoSimiBold",
                fontSize: 11,
                bold: true,
                margin: [0, 0],
                alignment: "right",
              } : {},

              ],
              [
                {
                  text: obj?.tot?.tot_net?.toFixed(2),
                  // font: "DroidKufiRegular",
                  fontSize: 15,
                  bold: true,
                  margin: [0, 0],
                  alignment: "center",
                },
                {
                  text: reverseArabicAndEnglish("الاجمالي شامل الضريبه"),
                  font: "DroidKufiRegular",
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0],
                  alignment: "right",
                },

              ],
              [
                {
                  layout: "totalPLayout",
                  table: {
                    headerRows: 0,
                    widths: ["*", "auto"],
                    dontBreakRows: true,
                    body: [
                      [
                        {
                          text: (obj?.tot?.tot_net?.toFixed(2) - obj?.tot?.paid).toFixed(2),
                          bold: true,
                          alignment: "center",
                          fontSize: 13,
                        },
                        {
                          text: "متبقي",
                          bold: true,
                          alignment: "right",
                          fontSize: 13,
                        },
                      ],
                    ],
                  },
                },
                {
                  layout: "totalPLayout",
                  table: {
                    headerRows: 0,
                    widths: ["*", "auto"],
                    dontBreakRows: true,
                    body: [
                      [
                        {
                          text: obj?.tot?.paid.toFixed(2),
                          bold: true,
                          alignment: "center",
                          fontSize: 13,
                        },
                        {
                          text: "مدفوع",
                          bold: true,
                          alignment: "right",
                          fontSize: 13,
                        },
                      ],
                    ],
                  },
                },
              ],
            ],
          },
        },
        {
          layout: "totalPLayout",
          table: {
            headerRows: 0,
            widths: ["*", "auto"],
            dontBreakRows: true,
            body: [
              [
                {
                  // width: "*",
                  image: `data:image/jpeg;base64,${obj?.inv?.qr_image}`,
                  height: 120,
                  width: 120,
                  // stack: qrArr,
                },
                {
                  text: "\n" + reverseArabicAndEnglish("المندوب") + "\n"
                    + reverseArabicAndEnglish(obj?.tot?.sales_emp_name),
                  // font: "DroidKufiRegular",
                  fontSize: 14,
                  bold: true,
                  margin: [0, 0],
                  alignment: "center",
                },
              ],
            ],
          },
        },
        {
          text: prepareBillNotes(obj?.found?.BillNotes, 45),
          font: "CairoBold",
          fontSize: 10,
          bold: true,
          margin: [0, 0, 0, 0],
          // alignment: "right",
          // direction:"rtl",
          alignment: "right",
        },

      ],
      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
          color: "black",
        },
        tableHeader: {
          bold: true,
          fontSize: 8,
          color: "black",
        },
      },

      pageMargins: [10, 10, 10, 10],
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };
    return docDefinition;
  };

  static generateDocDefTemplate8 = (obj) => {
    const { pageSize, pageOrientation, qrCodeActive, qrCode } =
      this.docDefinition;
    const { backgroundColor, watermark, columns, headerSettings } =
      this.bill4Settings;
    let itemHeader = [
      {
        text: reverseArabicAndEnglish("الإجمالي"),
        style: "tableHeader",
        fontSize: 8,
        alignment: "center",
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("السعر"),
        style: "tableHeader",
        alignment: "center",
        bold: true,
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("الكمية"),
        style: "tableHeader",
        alignment: "center",
        bold: true,
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("اسم الصنف"),
        style: "tableHeader",
        alignment: "right",
        bold: true,
        font: "DroidKufiRegular",
      },
    ];
    // itemWidths.push("auto");
    let itemBody = [itemHeader];
    let itemArr = ["", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      const propName = `${columns.colmProductDesc?.fieldName?.toString()}`;
      // console.log("the item is", propName);
      let itemRow = [];
      itemRow.push({ text: element["tot_net_curr"], alignment: "center", fontSize: 16, });
      itemRow.push({
        text: element["new_exchange_price"],
        alignment: "center",
        fontSize: 16,
      });

      itemRow.push({
        text: element["val1"],
        alignment: "right",
        fontSize: 16,
      });
      itemRow.push({
        // text: [...handleArabicCharacters(element["symbol"])],
        text: prepareBillNotes(element["symbol"], 21),
        font: "CairoBold",
        alignment: "right",
        fontSize: 10,
      });
      itemBody.push(itemRow);
    }

    pdfMake.tableLayouts = {
      totalLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#aaa";
        },
        fillColor: function (i, node) {
          return i === 3 ? backgroundColor : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          return 3;
        },
        paddingTop: function (i, node) {
          return 1;
        },
        paddingBottom: function (i, node) {
          return 1;
        },
      },
      totalPLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#fff";
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          return 0;
        },
        paddingTop: function (i, node) {
          return 0;
        },
        paddingBottom: function (i, node) {
          return 0;
        },
      },
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 1;
          }
          return i === node.table.headerRows ? 2 : 1;
        },
        vLineWidth: function (i) {
          return 1;
        },
        hLineColor: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return "black";
          }
          return i === 1 ? "black" : "#aaa";
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          return 1;
        },
        paddingTop: function (i, node) {
          return 1;
        },
        paddingBottom: function (i, node) {
          return 1;
        },
      },
    };
    // -- Set the report date for display only.

    let qrArr = [];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      qrArr.push("\n");
      qrArr.push({
        qr:
          qrCode.qr + (qrCode?.appendInvoiceNo === false ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "left",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    var docDefinition = {
      pageSize: { width: 260, height: "auto" },
      pageOrientation: pageOrientation,

      content: [
        {
          image: obj.imgSrc
            ? obj.imgSrc
            : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
          width: 80,
          height: 80,
          alignment: "center",
        },
        {
          // text: reverseArabicAndEnglish(obj?.found?.nameA),
          text: prepareBillNotes(obj?.found?.nameA, 42),
          font: "CairoBold",
          alignment: "center",
          fontSize: 11,
          bold: true,
          margin: [0, 1],
        },
        {
          // text: reverseArabicAndEnglish(obj?.found?.Address),
          text: prepareBillNotes(obj?.found?.Address, 42),
          font: "CairoBold",
          alignment: "center",
          fontSize: 11,
          bold: true,
          margin: [0, 1],
        },

        {
          layout: "totalPLayout",
          table: {
            headerRows: 0,
            widths: ["*", 100],
            dontBreakRows: true,
            body: [
              [
                {
                  text: "Phone No:" + reverseArabicAndEnglish(obj?.found?.Mobile),
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0],
                },
                {
                  text: reverseArabicAndEnglish(obj?.found?.Fax),
                  bold: true,
                  alignment: "right",
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 9,
                },
              ],
              [
                {
                  text: reverseArabicAndEnglish(obj?.found?.tax_no),
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 12,
                  bold: true,
                },
                {
                  text: reverseArabicAndEnglish("الرقم الضريبي"),
                  bold: true,
                  alignment: "right",
                  // fontSize: 11,
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 10,
                },
              ],
              [
                {
                  text: obj?.found?.bsn_no,
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 13,
                  bold: true,
                  margin: [0, 0],
                },
                {
                  text: reverseArabicAndEnglish("السجل التجاري"),
                  bold: true,
                  alignment: "right",
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 10,
                },
              ],
              [
                {
                  text: obj?.tot?.id,
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 13,
                  bold: true,
                },
                {
                  text: reverseArabicAndEnglish("رقم الفاتورة"),
                  bold: true,
                  alignment: "right",
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 10,
                },
              ],
              [
                {
                  text: obj?.tot?.OrderNo + " " + " الطلب " + "رقم",
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 11,
                  bold: true,
                },
                {
                  text: obj?.tot?.OrderTypeA + "الطلب" + " " + "نوع",
                  bold: true,
                  alignment: "right",
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 11,
                },
              ],

            ],
          },
        },
        obj?.tot?.tawlaName !== "" ? {
          text: reverseArabicAndEnglish(obj?.tot?.tawlaName ?? ""),
          alignment: "center",
          fontSize: 12,
          bold: true,
        } : null,
        {
          text:
            obj?.tot?.tax_no_cust === ""
              ? reverseArabicAndEnglish("فاتورة ضريبية مبسطة")
              : reverseArabicAndEnglish("فاتورة ضريبية"),
          alignment: "center",
          font: "DroidKufiRegular",
          fontSize: 11,
          bold: true,
        },
        {
          text: reverseArabicAndEnglish(
            obj?.locInv?.invN +
            " " +
            (!obj?.premiApp?.hidePayType
              ? obj?.tot?.inv_type_name + "" + obj?.tot?.pay_type_name
              : "") +
            (obj?.premiApp?.hidePayType && obj?.tot?.inv_type_name == "نقدية"
              ? obj?.tot?.inv_type_name
              : "")
          ),
          alignment: "center",
          font: "DroidKufiRegular",
          fontSize: 11,
          bold: true,
          // margin: [0, 1],
        },

        {
          text: "customer:" + reverseArabicAndEnglish(obj?.tot?.cust_name) +
            " " +
            "Date:" + moment(obj?.tot?.date).format("YYYY-MM-DD,h:mm"),
          alignment: "center",
          font: "CairoBold",
          fontSize: 9,
          bold: true,
          margin: [0, 0],
        },
        {
          margin: [0, 0, 0, 0],
          layout: "exampleLayout",
          dontBreakRows: true,
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "auto", "*"],
            body: itemBody,
          },
        },
        {
          layout: "totalLayout",
          table: {
            headerRows: 0,
            widths: [90, "*"],
            dontBreakRows: true,
            body: [
              [

                {
                  text: ((obj?.tot?.tot_net - obj?.tot?.amountOfVat + obj?.tot?.discount) - parseFloat(obj?.tot?.tab3Vat ?? 0))?.toFixed(2),
                  fontSize: 15,
                  bold: true,
                  alignment: "center",
                },
                {
                  text: reverseArabicAndEnglish("الاجمالي قبل الضريبة"),
                  font: "DroidKufiRegular",
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0],
                  alignment: "right",
                },
              ],
              [
                {
                  text: obj?.tot?.discount?.toFixed(2),
                  // font: "DroidKufiRegular",
                  fontSize: 14,
                  bold: true,
                  margin: [0, 0],
                  alignment: "center",
                },
                {
                  // text: reverseArabicAndEnglish("الخصم"),
                  text: reverseArabicAndEnglish(" مجموع الخصومات"),
                  font: "DroidKufiRegular",
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0],
                  alignment: "right",
                },

              ],
              [
                {
                  text: obj?.tot?.amountOfVat?.toFixed(2),
                  // font: "DroidKufiRegular",
                  fontSize: 15,
                  bold: true,
                  margin: [0, 0],
                  alignment: "center",
                },
                {
                  text: "(15%)" + reverseArabicAndEnglish("إجمالي الضريبة"),
                  font: "NotoSimiBold",
                  fontSize: 11,
                  bold: true,
                  margin: [0, 0],
                  alignment: "right",
                },

              ],
              [obj?.tot?.tab3Vat > 0 ? {
                text: obj?.tot?.tab3Vat?.toFixed(2),
                // font: "DroidKufiRegular",
                fontSize: 15,
                bold: true,
                // margin: [0, 1],
                alignment: "center",
              } : null,
              obj?.tot?.tab3Vat > 0 ? {
                text: "%100" + reverseArabicAndEnglish("مجموع ضريبة التبغ"),
                font: "NotoSimiBold",
                fontSize: 11,
                bold: true,
                margin: [0, 0],
                alignment: "right",
              } : null,

              ],
              [
                {
                  text: obj?.tot?.tot_net?.toFixed(2),
                  // font: "DroidKufiRegular",
                  fontSize: 15,
                  bold: true,
                  margin: [0, 0],
                  alignment: "center",
                },
                {
                  text: reverseArabicAndEnglish("الاجمالي شامل الضريبه"),
                  font: "DroidKufiRegular",
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0],
                  alignment: "right",
                },

              ],

            ],
          },
        },
        {
          layout: "totalPLayout",
          table: {
            headerRows: 0,
            widths: ["*", "auto"],
            dontBreakRows: true,
            body: [
              [
                {
                  // width: "*",
                  image: `data:image/jpeg;base64,${obj?.inv?.qr_image}`,
                  height: 120,
                  width: 120,
                  // stack: qrArr,
                },
                {
                  text: "\n" + reverseArabicAndEnglish("المندوب") + "\n"
                    + reverseArabicAndEnglish(obj?.tot?.sales_emp_name),
                  // font: "DroidKufiRegular",
                  fontSize: 14,
                  bold: true,
                  margin: [0, 0],
                  alignment: "center",
                },
              ],
            ],
          },
        },
        {
          text: prepareBillNotes(obj?.terms, 45),
          font: "CairoBold",
          fontSize: 10,
          bold: true,
          margin: [0, 0, 0, 0],
          alignment: "right",
        },

      ],
      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 8,
          color: "black",
        },
      },

      pageMargins: [10, 10, 10, 10],
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };
  static generateDocDefTemplate888 = (obj) => {
    const { pageSize, pageOrientation, qrCodeActive, qrCode } =
      this.docDefinition;
    const { backgroundColor, watermark, columns, headerSettings } =
      this.bill4Settings;
    let itemHeader = [
      {
        text: reverseArabicAndEnglish("اسم الصنف"),
        style: "tableHeader",
        alignment: "right",
        bold: true,
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("الكمية"),
        style: "tableHeader",
        alignment: "center",
        bold: true,
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("السعر"),
        style: "tableHeader",
        alignment: "center",
        bold: true,
        font: "DroidKufiRegular",
      },
      {
        text: reverseArabicAndEnglish("الإجمالي"),
        style: "tableHeader",
        fontSize: 8,
        alignment: "center",
        font: "DroidKufiRegular",
      },
    ];

    let itemWidths = [15, "auto", "auto", "*"];

    // itemWidths.push("auto");
    let itemBody = [itemHeader];
    let itemArr = ["", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      const propName = `${columns.colmProductDesc?.fieldName?.toString()}`;
      console.log("the item is", propName);
      let itemRow = [];
      itemRow.push({
        text: [...handleArabicCharacters(element["symbol"])],
        alignment: "right",
        fontSize: 10,
      });
      itemRow.push({
        text: element["val1"],
        alignment: "right",
      });
      itemRow.push({
        text: element["new_exchange_price"],
        alignment: "center",
      });

      itemRow.push({ text: element["tot_net_curr"], alignment: "center" });
      itemBody.push(itemRow);
    }

    pdfMake.tableLayouts = {
      totalLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#aaa";
        },
        fillColor: function (i, node) {
          // return i === 0 ? "#e8e8e8" : i % 2 === 0 ? "#e8e8e8" : null;
          return i === 3 ? backgroundColor : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 1;
          }
          return i === node.table.headerRows ? 2 : 1;
        },
        vLineWidth: function (i) {
          return 1;
        },
        hLineColor: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return "black";
          }
          return i === 1 ? "black" : "#aaa";
        },
        // fillColor: function (i, node) {
        //   return i === 0 ? backgroundColor : null;
        // },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
    };
    // -- Set the report date for display only.

    let qrArr = [];
    if (qrCodeActive && (qrCode?.qr || qrCode?.appendInvoiceNo)) {
      qrArr.push("\n");
      qrArr.push({
        qr:
          qrCode.qr + (qrCode?.appendInvoiceNo === false ? obj.invoiceNo : ""),
        foreground: qrCode.foreground,
        background: qrCode.background,
        alignment: "left",
        fit: 130,
        eccLevel: qrCode.eccLevel,
      });
    }
    var docDefinition = {
      pageSize: { width: 260, height: "auto" },
      pageOrientation: pageOrientation,

      content: [
        {
          image: obj.imgSrc
            ? obj.imgSrc
            : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
          width: 80,
          height: 80,
          alignment: "center",
        },
        {
          text: reverseArabicAndEnglish(obj?.found?.nameA),
          alignment: "center",
          font: "DroidKufiRegular",
          fontSize: 9,
          bold: true,
          margin: [0, 1],
        },
        {
          text: "Phone No: " + reverseArabicAndEnglish(obj?.found?.Mobile),
          alignment: "center",
          fontSize: 8,
          // margin: [0, 5],
        },
        {
          text: "VAT# " + reverseArabicAndEnglish(obj?.found?.tax_no),
          alignment: "center",
          fontSize: 8,
          // margin: [0, 5],
        },
        {
          text: obj?.tot?.id,
          fontSize: 11,
          bold: true,
          lineHeight: 1,
          alignment: "center",
        },
        {
          text:
            obj?.tot?.tax_no_cust === ""
              ? reverseArabicAndEnglish("فاتورة ضريبية مبسطة")
              : reverseArabicAndEnglish("فاتورة ضريبية"),
          alignment: "center",
          font: "DroidKufiRegular",
          fontSize: 8,
        },
        {
          text: reverseArabicAndEnglish(
            obj?.locInv?.invN +
            " " +
            (!obj?.premiApp?.hidePayType
              ? obj?.tot?.inv_type_name + "" + obj?.tot?.pay_type_name
              : "") +
            (obj?.premiApp?.hidePayType && obj?.tot?.inv_type_name == "نقدية"
              ? obj?.tot?.inv_type_name
              : "")
          ),
          fontSize: 8,
          alignment: "center",
          font: "DroidKufiRegular",
        },

        {
          text: "customer: " + reverseArabicAndEnglish(obj?.tot?.cust_name),
          fontSize: 9,
          alignment: "left",
          // font: "DroidKufiRegular",
        },
        {
          text: "Date: " + moment(obj?.tot?.date).format("YYYY-MM-DD,h:mm"),
          alignment: "right",
          fontSize: 8,
        },
        // "\n",
        {
          margin: [0, 0, 0, 0],
          layout: "exampleLayout",
          dontBreakRows: true,
          table: {
            headerRows: 1,
            widths: ["*", "auto", "auto", "auto"],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
        },
        {
          layout: "totalLayout",
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 0,
            widths: ["*", 90],
            dontBreakRows: true,
            body: [
              [
                {
                  text: reverseArabicAndEnglish("الإجمالي"),
                  bold: true,

                  alignment: "right",
                },
                {
                  text: this.getTotalAmount(obj?.tot),
                  bold: false,
                  alignment: "center",
                },
              ],
              [
                {
                  text: reverseArabicAndEnglish("الخصم"),
                  bold: true,
                  alignment: "right",
                },
                {
                  text: obj?.tot?.discount?.toFixed(2),
                  bold: false,
                  alignment: "center",
                },
              ],
              [
                {
                  text: reverseArabicAndEnglish("مجموع ضريبة القيمة المضافة"),
                  bold: true,
                  alignment: "right",
                },
                {
                  text: obj?.tot?.amountOfVat?.toFixed(2),
                  bold: false,
                  alignment: "center",
                },
              ],
              [
                {
                  text: reverseArabicAndEnglish("الإجمالي مع الضريبة "),
                  bold: true,
                  alignment: "right",
                },
                {
                  text: obj?.tot?.tot_net?.toFixed(2),
                  bold: true,
                  alignment: "center",
                },
              ],
            ],
          },
        },
        {
          // width: "*",
          image: `data:image/jpeg;base64,${obj?.inv?.qr_image}`,
          height: 100,
          width: 100,
          // stack: qrArr,
        },

        // {
        //   columns: [
        //     {
        //       layout: "lightHorizontalLines",
        //       table: {
        //         // headers are automatically repeated if the table spans over multiple pages
        //         // you can declare how many rows should be treated as headers
        //         headerRows: 0,
        //         widths: [70, 70, 70, 70, 70, 70],
        //         body: [
        //           [
        //             {
        //               text: reverseArabicAndEnglish("المتبقي"),

        //               fontSize: 9,
        //               bold: true,
        //               font: "DroidKufiRegular",
        //               alignment: "right",
        //             },
        //             {
        //               text:
        //                 obj?.tot?.inv_type_name == "نقدية"
        //                   ? 0
        //                   : obj?.tot?.tot_net?.toFixed(2) - obj?.tot?.paid,
        //               bold: false,
        //               alignment: "left",
        //             },
        //             {
        //               text: reverseArabicAndEnglish("المدفوع"),
        //               bold: true,
        //               fontSize: 9,

        //               font: "DroidKufiRegular",
        //               alignment: "right",
        //             },
        //             {
        //               text:
        //                 obj?.tot?.inv_type_name == "نقدية"
        //                   ? obj?.tot?.tot_net?.toFixed(2)
        //                   : obj?.tot?.paid,
        //               bold: false,
        //               alignment: "left",
        //             },

        //             {
        //               text: reverseArabicAndEnglish("إجمالي الكمية"),
        //               font: "DroidKufiRegular",
        //               fontSize: 9,
        //               alignment: "right",
        //             },
        //             {
        //               text: this.getQtyTotal(obj?.items),
        //               bold: false,
        //               alignment: "left",
        //             },
        //           ],
        //         ],
        //       },
        //     },
        //   ],
        // },
        // {
        //   stack: [
        //     {
        //       text:
        //         obj.terms !== ""
        //           ? "ملاحظات\n" + reverseArabicAndEnglish(obj?.terms)
        //           : "",
        //       fontSize: 10,
        //       alignment: "right",
        //     },
        //     "\n",
        //   ],
        // },
      ],
      styles: {
        // header: {
        //   fontSize: 15,
        //   bold: true,
        //   margin: [0, 10, 0, 10],
        // },
        // subheader: {
        //   fontSize: 16,
        //   bold: true,
        //   margin: [0, 10, 0, 5],
        // },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 8,
          color: "black",
        },
      },

      pageMargins: [10, 10, 10, 10],
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };
  // Template 9
  static generateDocDefTemplate9 = (obj) => {
    const { pageSize, pageOrientation, qrCodeActive, qrCode } =
      this.docDefinition;
    const { backgroundColor, watermark, columns, headerSettings } =
      this.bill4Settings;
    let itemHeader = [
      {
        text: reverseArabicAndEnglish("الكمية"),
        style: "tableHeader",
        alignment: "center",
        bold: true,
        font: "CairoBold",
        fontSize: 12,
        visible: true,
      },
      {
        text: reverseArabicAndEnglish("السعر"),
        style: "tableHeader",
        alignment: "center",
        bold: true,
        font: "CairoBold",
        fontSize: 12,
        visible: obj?.copy === 4 ? false : true,
      },
      {
        text: reverseArabicAndEnglish("اسم الصنف"),
        style: "tableHeader",
        alignment: "right",
        bold: true,
        font: "CairoBold",
        fontSize: 12,
        visible: true,
      },
    ];

    let HeadersItems = itemHeader?.filter((d) => d.visible);

    let itemBody = [HeadersItems];
    let itemArr = ["", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
      const element = obj.items[index];
      let itemRow = [];
      itemRow.push({
        text: element["val1"],
        alignment: "center",
        bold: true,
        fontSize: 16,
      });
      if (obj?.copy != 4) {
        itemRow.push({
          text: element["new_exchange_price"],
          alignment: "center",
          bold: true,
          fontSize: 16,
        });
      }
      itemRow.push({
        text: prepareBillNotes(element["symbol"], obj?.copy == 4 ? 25 : 22),
        font: "CairoBold",
        alignment: "right",
        fontSize: 10,
      });
      itemBody.push(itemRow);
    }

    pdfMake.tableLayouts = {
      totalLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#aaa";
        },
        fillColor: function (i, node) {
          // return i === 0 ? "#e8e8e8" : i % 2 === 0 ? "#e8e8e8" : null;
          return i === 3 ? backgroundColor : null;
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          //return i === node.table.widths.length - 1 ? 0 : 8;
          return 3;
        },
        paddingTop: function (i, node) {
          return 3;
        },
        paddingBottom: function (i, node) {
          return 3;
        },
      },
      totalPLayout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return "#fff";
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          return 0;
        },
        paddingTop: function (i, node) {
          return 0;
        },
        paddingBottom: function (i, node) {
          return 0;
        },
      },
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 1;
          }
          return i === node.table.headerRows ? 2 : 1;
        },
        vLineWidth: function (i) {
          return 1;
        },
        hLineColor: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return "black";
          }
          return i === 1 ? "black" : "#aaa";
        },
        paddingLeft: function (i) {
          return i === 0 ? 8 : 8;
        },
        paddingRight: function (i, node) {
          return 1;
        },
        paddingTop: function (i, node) {
          return 1;
        },
        paddingBottom: function (i, node) {
          return 1;
        },
      },
    };
    // -- Set the report date for display only.

    var docDefinition = {
      // pageSize: { width: 260, height: "auto" },
      pageSize: { width: 260, height: obj.items.length > 3 ? "auto" : 270 },

      pageOrientation: pageOrientation,

      content: [
        {
          layout: "totalPLayout",
          table: {
            headerRows: 0,
            widths: ["*", 100],
            dontBreakRows: true,
            body: [
              [
                {
                  text: obj?.tot?.id,
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 13,
                  bold: true,
                  margin: [0, 0],
                },
                {
                  text: reverseArabicAndEnglish("رقم الفاتورة"),
                  bold: true,
                  alignment: "right",
                  // fontSize: 11,
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 10,
                },
              ],
              [
                {
                  text: obj?.tot?.OrderNo,
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 13,
                  bold: true,
                  margin: [0, 0],
                },
                {
                  text: reverseArabicAndEnglish("رقم الطلب"),
                  bold: true,
                  alignment: "right",
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 10,
                },
              ],
              [
                {
                  text: obj?.tot?.OrderTypeA,
                  alignment: "center",
                  font: "CairoBold",
                  fontSize: 12,
                  bold: true,
                  margin: [0, 0],
                },
                {
                  text: reverseArabicAndEnglish("نوع الطلب"),
                  bold: true,
                  alignment: "right",
                  // fontSize: 11,
                  margin: [0, 0],
                  font: "CairoBold",
                  fontSize: 10,
                },
              ],
            ],
          },
        },
        {
          text: reverseArabicAndEnglish(obj?.tot?.tawlaName ?? ""),
          alignment: "center",
          font: "CairoBold",
          fontSize: 11,
          bold: true,
          // margin: [0, 1],
        },
        {
          text: "Date: " + moment(obj?.tot?.date).format("YYYY-MM-DD,h:mm"),
          alignment: "right",
          font: "CairoBold",
          fontSize: 12,
          bold: true,
          lineHeight: 1,
        },
        // "\n",
        {
          margin: [0, 0, 0, 0],
          layout: "exampleLayout",
          dontBreakRows: true,
          table: {
            headerRows: 1,
            widths: obj?.copy == 4 ? ["auto", "*"] : ["auto", "auto", "*"],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
        },
      ],
      styles: {
        // header: {
        //   fontSize: 15,
        //   bold: true,
        //   margin: [0, 10, 0, 10],
        // },
        // subheader: {
        //   fontSize: 16,
        //   bold: true,
        //   margin: [0, 10, 0, 5],
        // },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 8,
          color: "black",
        },
      },

      pageMargins: [10, 10, 10, 10],
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };

  // Template 10
  static openDrawerTemplate = (obj) => {
    const { pageOrientation } =
      this.docDefinition;

    // -- Set the report date for display only.

    var docDefinition = {
      pageSize: { width: 260, height: "auto" },
      pageOrientation: pageOrientation,

      content: [
        {
          text: reverseArabicAndEnglish("فتح الدرج "),
          fontSize: 11,
          bold: true,
          lineHeight: 1,
          alignment: "center",
        },

      ],

      pageMargins: [10, 10, 10, 10],
      defaultStyle: {
        columnGap: 15,
        font: "Amiri",
      },
    };

    return docDefinition;
  };

}

export default pdfExport;
